(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6801f8107bdc7365b0090c83";
              window.beaePageSetting.pageTitle = "Main Footer"; 
              window.beaePageSetting.pageType = "footer";

          let js_S9DBQUFI = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-xzz91iywsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xzz91iyw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xzz91iyw');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xzz91iyw: ', ex)
      };
    

      try {
        let argid = 'beae-v2f2ac4blinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-v2f2ac4b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-v2f2ac4b');
        args.el = args.els[0];
        ((v) => { const b=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");b===null||w===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-v2f2ac4b: ', ex)
      };
    

      try {
        let argid = 'beae-mru8hraslinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mru8hras',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mru8hras');
        args.el = args.els[0];
        ((v) => { const b=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");b===null||w===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mru8hras: ', ex)
      };
    

      try {
        let argid = 'beae-f4mkz9izlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f4mkz9iz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f4mkz9iz');
        args.el = args.els[0];
        ((v) => { const b=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");b===null||w===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f4mkz9iz: ', ex)
      };
    

      try {
        let argid = 'beae-rlwf0t9olinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-rlwf0t9o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-rlwf0t9o');
        args.el = args.els[0];
        ((v) => { const b=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");b===null||w===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-rlwf0t9o: ', ex)
      };
    

      try {
        let argid = 'beae-1la47wymblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1la47wym',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1la47wym');
        args.el = args.els[0];
        ((T) => { if(T.el){let H=T.el.querySelector(".beae-image-content-position"),z,I=T.autoHover;var E=H.querySelector(".beae-img-ratio-control"),N=H.querySelector(".beae-img-comp-container"),P=H.querySelector(".beae-img-comp-container--second");if(E&&P){let O=function(A){let D=0,G,q;W(),I?H.onmouseover=function(Y){Z(Y)}:A.onmousedown=function(Y){Z(Y)},H.onmouseup=function(){j()},A.ontouchstart=function(Y){Z(Y)},H.ontouchend=function(){j()};function W(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=P.offsetWidth})}).observe(P),A.style.left&&(G=parseInt(A.style.left))}function Z(Y){check=!1,Y.preventDefault(),Y.clientX?Y.clientX:Y.touches[0].clientX,G=parseInt(A.style.left),D=1,H.onmousemove=function(te){F(te)},H.ontouchmove=function(te){F(te)}}function j(){D=0,isNaN(q)||(G=q),check=!0}function F(Y){if(D==0)return!1;q=R(Y),q<0&&(q=0),q>100&&(q=100),U(q)}function R(Y){const te=H.getBoundingClientRect(),ae=Y.changedTouches?Y.changedTouches[0].clientX:Y.clientX,K=ae-te.left;let ie;return I?ie=Math.round(K*100/z):ie=Math.round(G-(ae-Y.pageX)*100/z),ie}function U(Y){A.style.left=Y+"%",P.style.clipPath=`polygon(${Y}% 0%, ${Y}% 100%, 100% 100%, 100% 0)`,N.style.clipPath=`polygon(0% 100%, 0% 0%, ${Y}% 0%, ${Y}% 100%)`}};E&&P&&O(E),window.addEventListener("resize",function(){E&&P&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=P.offsetWidth})}).observe(P),O(E))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1la47wym: ', ex)
      };
    }; if (window.BEAEBASE) {js_S9DBQUFI()} else {window.BEAEPAGEJS.push(js_S9DBQUFI)} })(); 